export const CASE_STATUS_FILTER_OPTIONS = [
  { value: '', label: 'Tous les statuts' },
  { value: 'draft', label: 'Brouillon' },
  { value: 'submitted', label: 'Soumis' },
  { value: 'in_progress', label: 'En cours' },
  { value: 'completed', label: 'Terminé' },
  { value: 'cancelled', label: 'Annulé' },
];

const RAW_STATUS_TO_CANON = {
  draft: 'draft',
  submitted: 'submitted',
  in_progress: 'in_progress',
  in_review: 'in_progress',
  on_hold: 'in_progress',
  pending: 'in_progress',
  blocked: 'in_progress',
  in_production: 'in_progress',
  quality_check: 'in_progress',
  ready_for_delivery: 'in_progress',
  completed: 'completed',
  delivered: 'completed',
  cancelled: 'cancelled',
};

const BADGE_CONFIG = {
  draft: {
    label: 'Brouillon',
    className: 'bg-muted text-muted-foreground border border-border',
  },
  submitted: {
    label: 'Soumis',
    className: 'bg-primary/10 text-primary border border-primary/20',
  },
  in_progress: {
    label: 'En cours',
    className: 'bg-warning/10 text-warning border border-warning/20',
  },
  completed: {
    label: 'Terminé',
    className: 'bg-success/10 text-success border border-success/20',
  },
  cancelled: {
    label: 'Annulé',
    className: 'bg-muted text-muted-foreground border border-border',
  },
};

export function normalizeCaseStatusFilterParam(rawStatus) {
  const status = String(rawStatus || '').trim();
  if (!status || status === 'archived') return '';
  return RAW_STATUS_TO_CANON[status] || '';
}

export function getCaseStatusCanonForDisplay(rawStatus) {
  const status = String(rawStatus || '').trim();
  return RAW_STATUS_TO_CANON[status] || 'in_progress';
}

export function caseMatchesStatusFilter(rawStatus, filterStatus) {
  const canonFilter = normalizeCaseStatusFilterParam(filterStatus);
  if (!canonFilter) return true;
  return getCaseStatusCanonForDisplay(rawStatus) === canonFilter;
}

export function getCaseStatusBadgeConfig(rawStatus) {
  const canon = getCaseStatusCanonForDisplay(rawStatus);
  const config = BADGE_CONFIG[canon];
  return {
    canon,
    ...config,
    ariaLabel: `Statut : ${config.label}`,
  };
}
